import { DataSource, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommControlZmit extends Layout {
    panelZmitSection: Panel;
    sourceMCControl: DataSource;
    switchZmitAddFuelstops: Switch;
    switchZmitEmptyMiles: Switch;
    switchZmitOrderRoute: Switch;
    switchZmitSendEstimatedPay: Switch;
    textboxAutoAddUser: Textbox;
    textboxDirections: Textbox;
    textboxDispatchForm: Textbox;
    textboxEmptyForm: Textbox;
    textboxRouteDistProfile: Textbox;
    textboxRouteForm: Textbox;
    textboxStopsForm: Textbox;
    textboxWireForm: Textbox;
    textboxZmitDirections: Textbox;
    textboxZmitMiles: Textbox;
}
